export default __webpack_public_path__ + "static/08-864663f72ef7b77d954323c388cb7ed7.png";